Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Caption1373977966",
  {"root":"Caption1373977966--root","c1":"Caption1373977966--c1"},
  ".Caption1373977966--c1,.Caption1373977966--root[data-text391954719-size=medium][data-text391954719-weight=bold][data-caption1373977966-caption=c1]{font-size:10px;line-height:12px}",
  9,
  "Caption1373977966"
);
__webpack_require__.stylable.$.register(exports.default)
